import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class LiquidationReportService {


  constructor(private _http: HttpClient) {}

  getLiquidation(page): Observable<any[]> {
    return this._http.post<any[]>(`${environment.BACKEND}liquidacion/report`, page);
  }

  getStage(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.BACKEND}liquidacion/stage`);
  }

}
